import React from 'react';
import logo from '../assets/logo-text.svg';

const Logo = () => {
  return <img width="100%" src={logo} alt={'Logo'} />;
};

export default Logo;
